import { Fee } from 'types';

export const createFixedFee = (value: string): Fee => ({
  type: 'FIXED',
  value: parseFloat(value) >= 0 ? parseFloat(value) : 0,
});
